module.exports = __webpack_public_path__ + "static/the-best-we-could-do-02a4000fd2ded9f2bf69b611794792b3.jpg";